export const GET_DMX_CONTROLLERS = 'GET_DMX_CONTROLLERS';
export const GET_DMX_CONTROLLERS_SUCCESS = 'GET_DMX_CONTROLLERS_SUCCESS';
export const GET_DMX_CONTROLLERS_ERROR = 'GET_DMX_CONTROLLERS_ERROR';
